import bunyan from 'bunyan';
import getConfig from 'next/config';

import { NextConfig } from 'src/types';

const { serviceName } = (getConfig() as NextConfig).publicRuntimeConfig.datadog;

export const logger = bunyan.createLogger({
  name: serviceName,
});
